import { Box, Flex, Text, Container, Image } from '@everlywell/ui-kit';
import React from 'react';

interface TestimonialBannerProps {
  sectionImage: {
    url: string;
  };
  quote?: string;
  attribution?: string;
  backgroundColor?: string;
}

const TestimonialBanner = ({
  sectionImage,
  quote,
  attribution,
  backgroundColor,
}: TestimonialBannerProps) => (
  <Box position="relative" overflow="hidden" mt={8}>
    <Container size="fluid">
      <Flex
        direction={['column', 'row', 'row']}
        alignItems="center"
        backgroundColor={backgroundColor}
        rounded={'xl'}
      >
        {/* Quote Section */}
        <Box flex="1" p={[6, 8, 10]} maxWidth={['100%', null, '50%']}>
          <Text
            fontSize={['2xl', '4xl']}
            color="gray.800"
            fontWeight="normal"
            marginBottom={4}
            lineHeight="1.2"
          >
            {quote}
          </Text>
          <Text fontSize="md" color="gray.600">
            {attribution}
          </Text>
        </Box>

        {/* Image Section */}
        <Box
          flex="1"
          height={['300px', '375px', '375px']}
          position="relative"
          width="100%"
        >
          <Image
            src={sectionImage?.url}
            alt={sectionImage?.url}
            objectFit="cover"
            objectPosition="left"
            height="100%"
            width="100%"
          />
        </Box>
      </Flex>
    </Container>
  </Box>
);

export default TestimonialBanner;
